export default __webpack_public_path__ + "static/media/getir-logo.ac808e78.svg";